import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import SimpleBar from 'simplebar-react';
import MetisMenu from 'metismenujs';
import withRouter from 'components/Common/withRouter';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const SaaSVSidebarContent = (props) => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add('active');
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show');
    }

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show');
        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add('mm-active');
          parent3.childNodes[0].classList.add('mm-active');
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add('mm-show');
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add('mm-show');
              parent5.childNodes[0].classList.add('mm-active');
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains('active')) {
        item.classList.remove('active');
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.remove('mm-show');
        }

        parent.classList.remove('mm-active');
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove('mm-show');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('mm-active');
            parent3.childNodes[0].classList.remove('mm-active');

            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('mm-show');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('mm-show');
                parent5.childNodes[0].classList.remove('mm-active');
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById('side-menu');
    const items = ul.getElementsByTagName('a');
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu('#side-menu');
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t('SaaS Management')}</li>
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t('Dashboard')}</span>
              </Link>
            </li>

            <li>
              <Link to="/tenants" className="has-arrow">
                <i className="bx bx-buildings"></i>
                <span>{props.t('Tenants')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/saas/tenants">{props.t('Tenants')}</Link>
                </li>
                <li>
                  <Link to="/saas/tenant-requests">{props.t('Requests')}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/catalog" className="has-arrow">
                <i className="bx bx-package"></i>
                <span>{props.t('Catalog Management')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/saas/catalog-items">{props.t('Catalog Items')}</Link>
                </li>
                <li>
                  <Link to="/saas/shared-categories">{props.t('Categories')}</Link>
                </li>
                <li>
                  <Link to="/saas/item-units">{props.t('Item Units')}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/users" className="">
                <i className="bx bx-user"></i>
                <span>{props.t('Users')}</span>
              </Link>
            </li>

            <li>
              <Link to="/roles" className="has-arrow">
                <i className="bx bx-shield"></i>
                <span>{props.t('Roles & Permissions')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/roles/list">{props.t('Roles')}</Link>
                </li>
                <li>
                  <Link to="/permissions/list">{props.t('Permissions')}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/pricing-plans" className="">
                <i className="bx bx-money"></i>
                <span>{props.t('Pricing Plans')}</span>
              </Link>
            </li>

            <li>
              <Link to="/subscriptions" className="">
                <i className="bx bx-subscription"></i>
                <span>{props.t('Subscriptions')}</span>
              </Link>
            </li>

            <li>
              <Link to="/promotions" className="">
                <i className="bx bx-purchase-tag"></i>
                <span>{props.t('Promotions')}</span>
              </Link>
            </li>

            <li>
              <Link to="/tickets" className="has-arrow">
                <i className="bx bx-support"></i>
                <span>{props.t('Support Tickets')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/tickets/list">{props.t('Ticket List')}</Link>
                </li>
                <li>
                  <Link to="/tickets/history">{props.t('Ticket History')}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/notifications" className="">
                <i className="bx bx-bell"></i>
                <span>{props.t('Notifications')}</span>
              </Link>
            </li>

            <li>
              <Link to="/audit-logs" className="">
                <i className="bx bx-history"></i>
                <span>{props.t('Audit Logs')}</span>
              </Link>
            </li>

            <li>
              <Link to="/otp-verifications" className="">
                <i className="bx bx-key"></i>
                <span>{props.t('OTP Verifications')}</span>
              </Link>
            </li>

            <li className="menu-title">{props.t('Authentication')}</li>
            <li>
              <Link to="/auth" className="has-arrow">
                <i className="bx bx-user-circle"></i>
                <span>{props.t('Authentication')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/auth/login">{props.t('Login')}</Link>
                </li>
                <li>
                  <Link to="/auth/refresh-tokens">{props.t('Refresh Tokens')}</Link>
                </li>
              </ul>
            </li>

            <li className="menu-title">{props.t('Settings')}</li>
            <li>
              <Link to="/settings" className="">
                <i className="bx bx-cog"></i>
                <span>{props.t('Settings')}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SaaSVSidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SaaSVSidebarContent));
